module.exports = __webpack_public_path__ + "img/pink_mannequin_3_plus.fd5feb40.png";